module.exports = __webpack_public_path__ + "assets/roboto-v30-latin_latin-ext-100.2cf5056e82b206c7df681ca9043499ec.woff2";